<script setup>
  import { ref } from 'vue';
  import BaseModal from '~/components/base/BaseModal.vue';
  import BaseButton from '~/components/base/BaseButton.vue';

  const isShowingModal = ref(true);

  async function closeModal() {
    isShowingModal.value = false;
  }
  async function gotToPermissionsPage() {
    window.location.href = '/dashboard/manage-users-and-permissions';
  }
</script>

<template>
  <BaseModal
    v-if="isShowingModal"
    rounded
    dropShadow
    size="md"
    color="dark-grey"
    @background-clicked="closeModal()"
  >
    <h1 class="poc-confirmation__header">Permissions and Access Review</h1>
    <p class="poc-confirmation__text">
      Please review the permissions and admin access levels for users who have
      access to your company data by clicking here.
    </p>
    <BaseButton
      class="poc-confirmation__button"
      @click="gotToPermissionsPage()"
    >
      Go to Manage Users and Permissions Page
    </BaseButton>
  </BaseModal>
</template>

<style lang="scss" scoped>
  .poc-confirmation {
    &__header {
      margin-bottom: 2rem;
      text-align: center;
    }

    &__text {
      color: #183961;
    }

    &__button {
      display: block;
      margin-top: 2rem;
      margin-left: auto;
      margin-right: auto;
      text-transform: uppercase;
    }
  }
</style>
